import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { GeoAltFill, TelephoneFill, EnvelopeFill, SendFill } from "react-bootstrap-icons"; // İkonlar
import { supabase } from "../supabaseClient/supabaseClient";

const Iletisim = () => {
  // --- STATE YÖNETİMİ ---
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const [feedbackMsg, setFeedbackMsg] = useState({ type: "", msg: "" });

  // --- HANDLERS ---
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedbackMsg({ type: "", msg: "" });

    try {
      const { data: { user } } = await supabase.auth.getUser();

      const { error } = await supabase
        .from('feedback')
        .insert([
          {
            user_id: user ? user.id : null,
            type: formData.subject,
            message: formData.message,
            contact_info: `${formData.name} (${formData.email})`,
            status: 'pending'
          }
        ]);

      if (error) throw error;

      setFeedbackMsg({ type: "success", msg: "Mesajınız başarıyla bize ulaştı. En kısa sürede dönüş yapacağız." });
      setFormData({ name: "", email: "", subject: "", message: "" });

    } catch (error) {
      console.error("Hata:", error);
      setFeedbackMsg({ type: "danger", msg: "Gönderim hatası: " + error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page-wrapper">
      
      {/* --- CSS STYLES (Bu dosya özelinde) --- */}
      <style>{`
        .contact-page-wrapper {
          background: linear-gradient(135deg, #000b18 0%, #001f3f 50%, #003366 100%);
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          position: relative;
          overflow: hidden;
        }
        
        /* Arka plan dekoratif daireler */
        .decoration-circle {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          z-index: 0;
        }
        .circle-1 { top: -10%; left: -10%; width: 400px; height: 400px; background: rgba(0, 123, 255, 0.15); }
        .circle-2 { bottom: -10%; right: -10%; width: 500px; height: 500px; background: rgba(102, 16, 242, 0.15); }

        /* Ana Kart */
        .contact-card {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          position: relative;
          z-index: 1;
          display: flex;
          flex-wrap: wrap;
        }

        /* Sol Taraf (Bilgi Alanı) */
        .info-panel {
          background-color: #001f3f;
          background-image: linear-gradient(160deg, #001f3f 0%, #003366 100%);
          color: white;
          padding: 50px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          position: relative;
          overflow: hidden;
        }
        
        /* Sol taraf desen efekti */
        .info-panel::before {
          content: "";
          position: absolute;
          bottom: -50px;
          right: -50px;
          width: 200px;
          height: 200px;
          border-radius: 50%;
          border: 40px solid rgba(255,255,255,0.05);
        }

        .contact-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 30px;
        }
        .contact-icon {
          background: rgba(255,255,255,0.1);
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 20px;
          font-size: 1.5rem;
          color: #66b0ff;
          flex-shrink: 0;
        }

        /* Sağ Taraf (Form Alanı) */
        .form-panel {
          background-color: #ffffff;
          padding: 50px;
          flex: 1;
        }

        .form-control-custom {
          background-color: #f8f9fa;
          border: 2px solid #e9ecef;
          border-radius: 10px;
          padding: 12px 15px;
          transition: all 0.3s ease;
        }
        .form-control-custom:focus {
          background-color: #fff;
          border-color: #003366;
          box-shadow: 0 0 0 4px rgba(0, 51, 102, 0.1);
        }
        .form-label {
          font-weight: 600;
          color: #343a40;
          font-size: 0.9rem;
          margin-bottom: 8px;
        }

        @media (max-width: 991px) {
          .contact-card { flex-direction: column; }
          .info-panel { padding: 40px 30px; }
          .form-panel { padding: 40px 30px; }
        }
      `}</style>

      {/* Dekoratif Arka Plan */}
      <div className="decoration-circle circle-1"></div>
      <div className="decoration-circle circle-2"></div>

      <Container>
        <div className="contact-card">
          
          {/* --- SOL TARAF: İletişim Bilgileri --- */}
          <Col lg={5} className="info-panel">
            <div>
              <h3 className="fw-bold mb-4 display-6">İletişime Geçin</h3>
              <p className="mb-5 text-white-50 lead">
                Projeleriniz, sorularınız veya iş birliği fikirleriniz için bize ulaşın. Ekibimiz size en kısa sürede dönüş yapacaktır.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon"><GeoAltFill /></div>
                  <div>
                    <h6 className="fw-bold mb-1">Adres</h6>
                    <span className="text-white-50 small">
                      Sırakapılar, Saltak Cd. No:58/2<br />
                      20100 Merkezefendi / Denizli
                    </span>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon"><TelephoneFill /></div>
                  <div>
                    <h6 className="fw-bold mb-1">Telefon</h6>
                    <span className="text-white-50 small">+90 258 264 89 31</span>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon"><EnvelopeFill /></div>
                  <div>
                    <h6 className="fw-bold mb-1">E-Posta</h6>
                    <span className="text-white-50 small">info@staibilisim.com</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Alt Kısım: Sosyal Medya veya Ekstra Not */}
            <div className="mt-5 mt-lg-0">
               <p className="small text-white-50 mb-0">© 2026 STAI Bilişim. Tüm hakları saklıdır.</p>
            </div>
          </Col>

          {/* --- SAĞ TARAF: İletişim Formu --- */}
          <Col lg={7} className="form-panel">
            <h4 className="fw-bold text-dark mb-4">Bize Yazın</h4>
            
            {feedbackMsg.msg && (
              <Alert variant={feedbackMsg.type} className="border-0 shadow-sm mb-4 rounded-3">
                {feedbackMsg.msg}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4" controlId="name">
                    <Form.Label>Ad Soyad</Form.Label>
                    <Form.Control
                      type="text"
                      className="form-control-custom"
                      placeholder="Adınız Soyadınız"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4" controlId="email">
                    <Form.Label>E-posta Adresi</Form.Label>
                    <Form.Control
                      type="email"
                      className="form-control-custom"
                      placeholder="ornek@mail.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-4" controlId="subject">
                <Form.Label>Konu</Form.Label>
                <Form.Control
                  type="text"
                  className="form-control-custom"
                  placeholder="Mesajınızın konusu nedir?"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="message">
                <Form.Label>Mesajınız</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  className="form-control-custom"
                  placeholder="Size nasıl yardımcı olabiliriz?"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <div className="d-grid">
                <Button
                  type="submit"
                  disabled={loading}
                  className="py-3 fw-bold shadow-sm"
                  style={{
                    backgroundColor: "#001f3f",
                    borderColor: "#001f3f",
                    borderRadius: "10px",
                    letterSpacing: "0.5px"
                  }}
                  onMouseEnter={(e) => {
                     e.target.style.backgroundColor = "#003366"; 
                     e.target.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                     e.target.style.backgroundColor = "#001f3f"; 
                     e.target.style.transform = "translateY(0)";
                  }}
                >
                  {loading ? (
                     <>
                       <Spinner as="span" animation="border" size="sm" className="me-2" />
                       Gönderiliyor...
                     </>
                  ) : (
                    <>
                      Mesajı Gönder <SendFill className="ms-2 mb-1" size={14} />
                    </>
                  )}
                </Button>
              </div>
            </Form>
          </Col>
        </div>
      </Container>
    </div>
  );
};

export default Iletisim;